import { render, staticRenderFns } from "./OpenLayersMap.vue?vue&type=template&id=4564e6a0&scoped=true"
import script from "./OpenLayersMap.vue?vue&type=script&lang=js"
export * from "./OpenLayersMap.vue?vue&type=script&lang=js"
import style0 from "./OpenLayersMap.vue?vue&type=style&index=0&id=4564e6a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4564e6a0",
  null
  
)

export default component.exports